<template>
  <div>
    <!-- <div class="shop-header">
      <div class="w">
        <div class="shop-name">{{ shop.shop_name }}</div>
        <div class="shop-more">
          <div class="item" :class="[is_collection && 'active']" @click="collectionShop">
            <i class="iconfont ea-icon-star"></i>
            <p>{{ is_collection ? '已收藏' : '收藏' }}</p>
          </div>
      <a href='javascript:;' @click="MixinOpenIm(shop)" class="item">
            <i class="iconfont ea-icon-service"></i>
            <p>客服</p> 
          </a>
          <router-link :to="'./goods-list?shop_id=' + shop.shop_id" class="item">
            <i class="iconfont ea-icon-more"></i>
            <p>更多</p>
          </router-link>
        </div>
      </div>
    </div> -->

    <div id="header">
      <div class="top-header">
        <en-logo />
        <en-search />
        <en-settleup />
      </div>
    </div>
    <!-- TODO: fix 功能未开发-->
    <div class="shop-nav">
      <div class="w">
        <div class="item category">
          <div>
            <h1>店铺分组</h1>
          </div>
          <div class="category-box">
            <div class="inner-category-box">
              <div v-for="cate in categories" :key="cate['shop_cat_id']" class="category-item">
                <router-link :to="'/shop/goods-list?shop_id=' + shop_id + '&shop_cat_id=' + cate['shop_cat_id']">
                  {{ cate['shop_cat_name'] }}
                </router-link>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="category-ite"> -->
        <template v-for="nav in navs">
          <a :href="nav['nav_url']" class="item" :key="nav.id" :target="nav.target ? '_self' : '_self'">{{ nav.name }}</a>
        </template>
        <!-- </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import * as API_Shop from '@/api/shop';
import * as API_Members from '@/api/members';
import { mapGetters } from 'vuex';

export default {
  name: 'shop-header',
  props: ['shop'],
  data() {
    return {
      // 店铺分类【分组】
      categories: [],
      // 店铺导航
      navs: [],
      // 是否已收藏
      is_collection: false,
    };
  },
  computed: {
    ...mapGetters(['user']),
    shop_id() {
      return this.shop.shop_id;
    },
  },
  mounted() {
    this.goToAnchor();
    /** 获取店铺分类【分组】 */
    API_Shop.getShopCategorys(this.shop_id).then(response => {
      let categories = response.filter(item => item.disable === 1);
      categories = categories.map(item => {
        item.children = item.children.filter(_item => _item.disable === 1);
        return item;
      });
      this.categories = categories;
    });
    /** 获取店铺导航 */
    API_Shop.getShopNav(this.shop_id).then(response => {
      this.navs = response;
    });
    // 如果已登录，获取是否已收藏店铺
    if (this.user) this.getShopIsCollect();
  },
  watch: {
    $route: 'goToAnchor',
  },
  methods: {
    /** 去描点处 */
    goToAnchor() {
      const { hash } = location;
      if (hash === '#shop-intro' || hash === '#shop-info') {
        // eslint-disable-next-line no-undef
        $('html,body').animate({ scrollTop: $(hash).offset().top }, 300);
      }
    },
    /** 收藏店铺 */
    collectionShop() {
      if (!this.user) {
        if (localStorage.getItem('from') && localStorage.getItem('from') == 'JRC') {
          console.log(window.location.href);
          let data = {
            fromShop: true,
            formShopUrl: window.location.href,
            data: '子页面主动触发通讯'
          };
          window.parent.postMessage(data, '*');
        } else {
          this.$message.error('请先登录！');
        }
        return false;
      }
      if (this.is_collection) {
        API_Members.deleteShopCollection(this.shop_id).finally(this.getShopIsCollect);
      } else {
        API_Members.collectionShop(this.shop_id).finally(this.getShopIsCollect);
      }
    },
    /** 获取店铺是否被收藏 */
    getShopIsCollect() {
      API_Members.getShopIsCollect(this.shop_id).then(response => {
        this.is_collection = response.message;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../assets/styles/color';

#header {
  // border-bottom: 1px solid $color-main;
  margin: auto;
  width: 1210px;
  .top-header {
    display: flex;
    justify-content: space-between;
    height: 67px;
    // padding-top: 30px;
    padding-top: 52px;
    /deep/ #logo {
      // width: 240px;
      // height: 60px;
      width: 158px;
      height: 58px;
    }
    .zyz-t1 {
      z-index: 100;
      position: absolute;
      height: 30px;
      margin: 19px auto;
      top: 50px;
      right: 260px;
      height: 14px;
      font-size: 14px;
      font-family: MicrosoftYaHei, MicrosoftYaHei-Regular;
      font-weight: bolder;
      text-align: left;
      color: #000000;
      line-height: 18px;
      li {
        position: relative;
        float: left;
        padding: 0 10px;
        .zyz-tb {
          width: 17px;
          height: 17px;
          position: relative;
          top: -2px;
        }
      }
    }
  }
}

img {
  width: 100%;
  height: 100%;
}
.shop-header {
  width: 100%;
  height: 120px;
  background: url('../../../assets/images/background-brown-paper.jpg') repeat-x left top;
  .w {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .shop-name {
    padding: 0 0 0 320px;
    height: 120px;
    line-height: 125px;
    font-size: 30px;
    color: #fff;
    background: url('../../../assets/images/icon-welcome.png') no-repeat left center;
  }
  .shop-more {
    display: flex;
    margin-top: 28px;
    .item {
      text-align: center;
      cursor: pointer;
      margin-left: 30px;
      color: #333;
      &.active {
        color: $color-main;
        i {
          color: $color-main;
        }
      }
      i {
        background-color: #fff;
        font-size: 26px;
        border-radius: 100%;
        color: #666;
        padding: 3px;
      }
      p {
        margin-top: 3px;
      }
    }
  }
}
.shop-nav {
  display: flex;
  height: 40px;
  h1 {
    font-size: 14px;
    color: #fff;
  }
  span {
    color: #dddbdb;
  }
  .item {
    font-size: 20px;
    line-height: 40px;
    color: #333;
    height: 40px;
    padding: 0 24px;
    display: inline-block;
    zoom: 1;
    font-weight: 500;
    a {
      width: 100%;
      height: 100%;
    }
  }
  .item a:hover {
    // color: $color-main;
    background: #fff;
    color: #e1251a;
  }
  // &:hover {
  //   .item-content {
  //     // background-color: rgba(0, 0, 0, 1);
  //     background: #DCDCDC;
  //     // color: #777777;
  //   }
  //   .item-layer {
  //     display: block;
  //   }
  // }
  &:hover {
    .item-content {
      // background-color: rgba(0, 0, 0, 1);
      background: #dcdcdc;
      // color: #777777;
    }
    .item-layer {
      display: block;
    }
  }
  .item.category {
    position: relative;
    display: inline-block;
    cursor: pointer;
    //  width: 190px;
    height: 40px;
    -ms-flex-negative: 0;
    flex-shrink: 0;
    z-index: 20;
    width: 190px;
    margin: 0;
    padding: 0;

    &:hover {
      .category-box {
        display: block;
      }
    }
    h1 {
      display: block;
      font-size: 20px;
      font-weight: 500;
      color: #333;
      text-align: center;
      line-height: 40px;

      -webkit-box-pack: center;
      -ms-flex-pack: center;
      justify-content: center;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
    }
    h1:hover {
      color: #fff;
      background: #e1251a;
    }
  }
  .category-box {
    display: none;
    position: absolute;
    z-index: 99;
    padding-top: 6px;
    background: white;
    width: 190px;
    .category-item a {
      width: 100%;
      height: 100%;
      font-weight: bolder;
      font-size: 14px;
      padding-left: 16px;
    }
  }
  .category-item:hover {
    background: #e5e6eb;
  }
  // .inner-category-box {
  //   width: 152px;
  //   background-color: rgba(255, 255, 255, .8);
  //   box-sizing: border-box;
  // .category {
  //   cursor: pointer;
  //   height: 70px;
  //   a:hover {
  //     // color: $color-main;
  //     background: #fff;
  //   }
  //   &:hover {
  //     .item-content {
  //       // background-color: rgba(0, 0, 0, 1);
  //       background: #DCDCDC;
  //       // color: #777777;
  //     }
  //     .item-layer {
  //       display: block;
  //     }
  //   }
  // }
  //   .category-item-box {
  //     display: none;
  //     position: absolute;
  //     top: 0;
  //     left: 100%;
  //     width: 130px;
  //     background-color: rgba(96, 96, 96, .8);
  //     .category-item-cc {
  //       border-bottom: 1px dashed #fff;
  //       padding: 0 10px;
  //       &:last-child {
  //         border-bottom: none
  //       }
  //       &:hover {
  //         background-color: rgba(96, 96, 96, 1);
  //       }
  //       a {
  //         display: block;
  //         color: #fff;
  //       }
  //     }
  //   }
  // }
}

// .category h1 {
//     display: block;
//     font-size: 20px;
//     font-weight: 500;
//     color: #333;
//     text-align: center;
//     line-height: 40px;
//     display: -webkit-box;
//     display: -ms-flexbox;
//     display: flex;
//     -webkit-box-pack: center;
//     -ms-flex-pack: center;
//     justify-content: center;
//     -webkit-box-align: center;
//     -ms-flex-align: center;
//     align-items: center;
//     }
//     .category {
//        width: 190px;
//     height: 40px;
//     -ms-flex-negative: 0;
//     flex-shrink: 0;
//     z-index: 20;
//     }
</style>



// WEBPACK FOOTER //
// src/views/shop/-shop/-shop-header.vue